//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FeedbackButton from "~/components/layout/FeedbackButton.vue";
export default {
  name: "ErrorInternal",
  components: { FeedbackButton },
};
